import { Grid, Typography } from "@mui/material";
import React from "react";
import { CustomerDetailInterface } from "../../Objects/Customer";

export interface MypageRegProps {
    customerData: CustomerDetailInterface
}

const MypageReg: React.FC<MypageRegProps> = ({
    customerData
}) => {
    return (
        <>
            {customerData.mypage_flug &&
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{ color: "#333399" }}>マイページ登録</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">{customerData.mypage_flug == "1" ? "登録済み" : "未登録"}</Typography>
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default MypageReg